import React from 'react';

import {getHeaderColumn} from 'relevant-items/RelevantItemsHeaderColumns';
import {SimpleTableSortState} from 'ui-library/simple-table/useSimpleTableSortState';
import * as DateUtil from 'util/DateUtil';
import sortedBy from 'util/sortedBy';

export interface RelevantRowData {
  id: string;
  name: string;
  referencedInText: JSX.Element;
  modifiedAt: string | null;
  location: string | null;
  chip: JSX.Element;
  onClick?: () => void;
}

export function plainReferenceText(text: string): JSX.Element {
  return React.createElement('span', null, text);
}

function extractTextFromReactNode(node: React.ReactNode): string {
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }

  if (Array.isArray(node)) {
    return node.map((n) => extractTextFromReactNode(n)).join('');
  }

  if (React.isValidElement(node)) {
    return extractTextFromReactNode(node.props.children);
  }

  return '';
}
function lowercaseIncludes(text: string, includesString: string): boolean {
  return text.toLowerCase().includes(includesString.toLowerCase());
}

export function matchName(relevantItem: RelevantRowData, searchQuery: string): boolean {
  return lowercaseIncludes(relevantItem.name, searchQuery);
}

export function matchModifiedAt(relevantItem: RelevantRowData, searchQuery: string): boolean {
  return (
    relevantItem.modifiedAt != null &&
    lowercaseIncludes(DateUtil.readableTime(relevantItem.modifiedAt), searchQuery)
  );
}

export function matchProjectFolder(relevantItem: RelevantRowData, searchQuery: string): boolean {
  return relevantItem.location != null && lowercaseIncludes(relevantItem.location, searchQuery);
}

export function matchReference(relevantItem: RelevantRowData, searchQuery: string): boolean {
  return lowercaseIncludes(extractTextFromReactNode(relevantItem.referencedInText), searchQuery);
}

export function getSortedRelevantItemRowData(
  relevantItems: Array<RelevantRowData>,
  sortState: Exclude<SimpleTableSortState, null>
): Array<RelevantRowData> {
  let sortedItems = relevantItems;
  const headerColumn = getHeaderColumn(sortState.columnKey as number);
  if (headerColumn) {
    sortedItems = sortedBy(relevantItems, [
      {
        accessor: headerColumn.propertyKey,
        naturalSort: true,
        reversed: sortState.sortDirection === 'arrow-up',
      },
    ]);
  }
  return sortedItems;
}
